import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    padding: 16,
    backgroundColor: '#fff',
  },
  cardPreview: {
    backgroundColor: Colors.RedPallete.redTwo,
    borderRadius: 16,
    padding: 20,
    marginBottom: 24,
  },
  brandContainer: {
    alignItems: 'flex-end',
  },
  brandLogo: {
    width: 50,
    height: 30,
    resizeMode: 'contain',
    backgroundColor: 'white',
  },
  brandPlaceholder: {
    color: '#fff',
    fontSize: 12,
  },
  cardNumberText: {
    color: '#fff',
    fontSize: 22,
    letterSpacing: 2,
    marginVertical: 16,
  },
  cardholderText: {
    color: '#fff',
    fontSize: 14,
  },
  expiryText: {
    color: '#fff',
    fontSize: 12,
    marginTop: 8,
  },
  input: {
    borderWidth: 1,
    borderColor: '#ccc',
    color: '#666',
    borderRadius: 8,
    padding: 12,
    marginBottom: 12,
    fontSize: 16,
  },
  saveButton: {
    padding: 16,
    borderRadius: 8,
    alignItems: 'center',
    marginTop: 12,
  },
  saveButtonText: {
    color: '#fff',
    fontWeight: 'bold',
  },
  spaceHeader: {
    marginTop: 30,
    marginBottom: 15,
  },
});
